import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const KEY = 'atlas-privacy-blur';
const PrivacyContext = createContext({ hidden: false, toggle: () => {} });

export function PrivacyProvider({ children }) {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === '1');

  useEffect(() => { localStorage.setItem(KEY, hidden ? '1' : '0'); }, [hidden]);

  const toggle = useCallback(() => setHidden((h) => !h), []);

  return <PrivacyContext.Provider value={{ hidden, toggle }}>{children}</PrivacyContext.Provider>;
}

export const usePrivacy = () => useContext(PrivacyContext);
